function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBrandWithText = function SvgBrandWithText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 216 48",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 215.162,
    height: 47.76,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2466"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "\\uB514\\uBBF8\\uACE0\\uC778"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.012,4.8l20.9,0l-0,5.6l-14.95,0l-0,15.7l17.45,0l-0,1c-0,1.3 -0.483,2.392 -1.45,3.275c-0.967,0.883 -2.25,1.325 -3.85,1.325l-18.1,0l-0,-26.9Zm26.2,0l5.85,0l-0,33.75l-5.85,0l-0,-33.75Z",
    style: {
      fill: "#333",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.012,31.2l-0,-26.4l22.9,0l-0,21.75c-0,1.3 -0.492,2.4 -1.475,3.3c-0.983,0.9 -2.275,1.35 -3.875,1.35l-17.55,0Zm5.7,-5.6l11.5,0l-0,-15.2l-11.5,0l-0,15.2Zm20.5,-20.8l5.85,0l-0,33.75l-5.85,0l-0,-33.75Z",
    style: {
      fill: "#333",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.962,4.85l25.95,0l-0,23.95l-5.95,0l-0,-18.35l-20,0l-0,-5.6Zm13.45,27.35l16.05,0l-0,1.05c-0,1.267 -0.483,2.342 -1.45,3.225c-0.967,0.883 -2.233,1.325 -3.8,1.325l-27.7,0l-0,-5.6l11.05,0l-0,-11.5l5.85,0l-0,11.5Z",
    style: {
      fill: "#333",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.362,4.8l5.8,0l-0,29l-5.8,0l-0,-29Zm-20.35,42.4l-0,-15.65l5.7,0l-0,10.05l20.45,0l-0,1.05c-0,1.267 -0.483,2.342 -1.45,3.225c-0.967,0.883 -2.233,1.325 -3.8,1.325l-20.9,0Zm5.95,-43.4c1.833,0 3.517,0.325 5.05,0.975c1.533,0.65 2.85,1.542 3.95,2.675c1.1,1.133 1.95,2.467 2.55,4c0.6,1.533 0.9,3.2 0.9,5c-0,1.8 -0.3,3.475 -0.9,5.025c-0.6,1.55 -1.45,2.892 -2.55,4.025c-1.1,1.133 -2.417,2.017 -3.95,2.65c-1.533,0.633 -3.217,0.95 -5.05,0.95c-1.867,0 -3.567,-0.317 -5.1,-0.95c-1.533,-0.633 -2.833,-1.517 -3.9,-2.65c-1.1,-1.133 -1.95,-2.475 -2.55,-4.025c-0.6,-1.55 -0.9,-3.225 -0.9,-5.025c0,-1.8 0.3,-3.467 0.9,-5c0.6,-1.533 1.45,-2.867 2.55,-4c1.067,-1.133 2.367,-2.025 3.9,-2.675c1.533,-0.65 3.233,-0.975 5.1,-0.975Zm-0,19.55c0.967,0 1.867,-0.175 2.7,-0.525c0.833,-0.35 1.567,-0.825 2.2,-1.425c0.633,-0.6 1.125,-1.325 1.475,-2.175c0.35,-0.85 0.525,-1.775 0.525,-2.775c0,-1 -0.175,-1.917 -0.525,-2.75c-0.35,-0.833 -0.842,-1.55 -1.475,-2.15c-0.633,-0.6 -1.367,-1.067 -2.2,-1.4c-0.833,-0.333 -1.733,-0.5 -2.7,-0.5c-0.967,0 -1.875,0.167 -2.725,0.5c-0.85,0.333 -1.592,0.8 -2.225,1.4c-0.633,0.6 -1.125,1.317 -1.475,2.15c-0.35,0.833 -0.525,1.75 -0.525,2.75c-0,1 0.175,1.925 0.525,2.775c0.35,0.85 0.842,1.575 1.475,2.175c0.633,0.6 1.375,1.075 2.225,1.425c0.85,0.35 1.758,0.525 2.725,0.525Z",
    style: {
      fill: "#333",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1607",
    d: "M13.075,17.187c-0,-2.651 -2.153,-4.804 -4.804,-4.804c-2.651,0 -4.804,2.153 -4.804,4.804l-0,13.191c-0,2.651 2.153,4.804 4.804,4.804c2.651,0 4.804,-2.153 4.804,-4.804l-0,-13.191Z",
    style: {
      fill: "#e83c77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1608",
    d: "M13.075,4.804c-0,-2.651 -2.153,-4.804 -4.804,-4.804c-2.651,0 -4.804,2.153 -4.804,4.804c-0,2.651 2.153,4.804 4.804,4.804c2.651,0 4.804,-2.153 4.804,-4.804Z",
    style: {
      fill: "#e83c77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1609",
    d: "M50.502,42.956c-0,-2.651 -2.153,-4.804 -4.804,-4.804l-40.894,0c-2.651,0 -4.804,2.153 -4.804,4.804c-0,2.651 2.153,4.804 4.804,4.804l40.894,0c2.651,0 4.804,-2.153 4.804,-4.804Z",
    style: {
      fill: "#e83c77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2912",
    d: "M47.035,20.393l-0,9.985c-0.065,2.593 -2.215,4.69 -4.809,4.69c-2.593,-0 -4.743,-2.097 -4.808,-4.69l-0,-11.985c-0.116,-2.548 -2.244,-4.581 -4.795,-4.581c-2.551,0 -4.679,2.033 -4.795,4.581l-0,11.981c-0.065,2.593 -2.215,4.69 -4.809,4.69c-2.593,-0 -4.743,-2.097 -4.808,-4.69l-0,-11.741c-0.002,-0.098 -0.003,-0.196 -0.003,-0.294c0,-7.796 6.327,-14.25 14.121,-14.406l0.59,0c7.794,0.156 14.121,6.61 14.121,14.406c-0,0.098 -0.001,0.196 -0.003,0.294l-0,1.76l-0.002,0Z",
    style: {
      fill: "#e83c77",
      fillRule: "nonzero"
    }
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBrandWithText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/brand-with-text.6c402dfe.svg";
export { ForwardRef as ReactComponent };